export default "__VITE_ASSET__MgAtxN$w__"